"use strict";

/* eslint-disable no-magic-numbers */
var hexDigits = '0123456789abcdef';
var UUIDLength = 32;
function createUUID() {
  var s = [];
  for (var i = 0; i < UUIDLength; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[12] = '4'; // Bits 12-15 of the time_hi_and_version field to 0010
  s[16] = hexDigits.substr(s[16] & 0x3 | 0x8, 1); // Bits 6-7 of the clock_seq_hi_and_reserved to 01

  var uuid = s.join('');
  return uuid;
}
module.exports = createUUID;